module.exports = __webpack_public_path__ + "static/media/a3.ed05112f.jpg";